import type { AgencyCategory, AgencyListTab } from '@saaga/shared/interfaces/agencies.interface'
import { PlusIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { allCategoryList } from '@/components/agencies/agencies.mock'
import { AgencyCategoryFilter } from '@/components/agencies/agency-category-filter.molecule'
import { Button } from '@/components/ui/button'

interface AgenciesFilterActionsProps {
  activeTab: AgencyListTab
  selectedCategoryList: AgencyCategory[]
  onCategoryToggle: (category: AgencyCategory) => void
  onClearAll: () => void
  onCreateAgency: () => void
}

export const AgenciesFilterActions = ({
  activeTab,
  selectedCategoryList,
  onCategoryToggle,
  onClearAll,
  onCreateAgency,
}: AgenciesFilterActionsProps): ReactNode => (
  <div className="agencies-filter-row flex items-center justify-between gap-4">
    <AgencyCategoryFilter
      categoryList={allCategoryList}
      selectedCategoryList={selectedCategoryList}
      onCategoryToggle={onCategoryToggle}
      onClearAll={onClearAll}
    />
    {activeTab === 'studio' && (
      <Button className="agencies-create-button gap-2 shrink-0" onClick={onCreateAgency}>
        <PlusIcon className="size-4" />
        Create your own agency
      </Button>
    )}
  </div>
)
